import {useCallback} from 'react';
import {SchemeLink} from '../../../../applink/SchemeLink';
import {PromotionCardType} from '../../../../design-system/organisms/PromotionCard/constants';
import {PromotionCard} from '../../../../design-system/organisms/PromotionCard/PromotionCard';
import {PromotionCardViewItem as PromotionCardViewItemType} from '../../../../graphql/generated/types';
import {CommonItemProps} from '../../type';

export function PromotionCardView({item}: CommonItemProps) {
  const {copy, thumbnail, title, todayGift, scheme} =
    item as PromotionCardViewItemType;

  // TODO: 선물받기 로직 구현
  const onClickButton = useCallback(() => {}, []);

  return (
    <SchemeLink scheme={scheme || undefined}>
      <PromotionCard
        title={title || ''}
        thumbnail={thumbnail}
        ticketType={todayGift?.ticketKind}
        ticketCount={todayGift?.ticketCount}
        received={todayGift?.isReceived}
        promotionText={copy}
        cardType={
          todayGift ? PromotionCardType.Gift : PromotionCardType.WaitFree
        }
        onClickButton={onClickButton}
      />
    </SchemeLink>
  );
}
